export enum EPhoneType {
  Home = 1,
  Mobile = 2,
  Commercial = 3,
}
